import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import LocalizedStrings from '../../components/Localization';

import { getSwitchConfirmation } from '../../api/documents';


class SwitchConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      switchConfirmation: undefined
    };

    this.updateAgreement = this.updateAgreement.bind(this);

    this.strings = LocalizedStrings({
      en: {
        loading: "Loading switch confirmation...",
        notFound: "No switch confirmation found.",
        backToAgreements: "Back to agreements"
      },
      nl: {
        loading: "Bevestiging van switch laden...",
        notFound: "Geen switchbevestiging gevonden.",
        backToAgreements: "Terug naar overeenkomsten"
      }
    }, this.props.lang);
  }

  static getDerivedStateFromProps(nextProps, prevState) {

    if (parseInt(nextProps.company_id) !== parseInt(nextProps.selectedCompany.company_id)) {

      let url = window.location.pathname.replace(nextProps.company_id.toString(), nextProps.selectedCompany.company_id.toString())

      return { redirectTo: url }
    }
    else

      return null
  }

  componentDidMount() {
    this.updateAgreement();
  }

  updateAgreement() {
    if (!this.props.selectedCompany) return;

    getSwitchConfirmation(
      this.props.company_id,
      this.props.document_key,
      (err, res) => {
        if (err)
          return window.reportError.send(err);

        if (res.error) {

          this.setState({
            error: this.strings.notFound
          });
        }
        else {

          this.setState({
            switchConfirmation: res || 'about:blank'
          });
        }
      }
    );
  }

  render() {
    if (this.state.redirectTo)
      return <Redirect to={this.state.redirectTo} />

    if (this.state.error) {
      return (
        <div className="text-center">
          <div className="spacer"></div>
          <div className="spacer"></div>
          <h4 className="font-weight-light text-muted mb-4">{this.state.error}</h4>
          <Link to="/documents/agreements" className="btn btn-secondary">{this.strings.backToAgreements}</Link>
          <div className="spacer"></div>
          <div className="spacer"></div>
        </div>
      )
    }

    if (!this.state.switchConfirmation) {
      return (<Loader>{this.strings.loading}</Loader>);
    }

    return (
      <div className="row">
        <div className="col-sm p-0">
          <iframe name="switchConfirmation" id="switchConfirmation" width="100%" height="800px" title="switchconfirmation" src={this.state.switchConfirmation}></iframe>
        </div>
      </div>
    );
  }
}

export default SwitchConfirmation;
